module.exports = __webpack_public_path__ + "static/media/agile-ge-logo.d8f833b0.svg";